// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"bind-record_listWrap_17FnH"};